import useSubscriptionStore from '../stores/subscriptionStore.js';
import useIsLimitReached from './useIsLimitReached.js';

function useAccessType(checkAccess = false) {
    const { isEssential, isDemo } = useSubscriptionStore();
    const isLimitReached = useIsLimitReached();

    const getAccessType = () => {
        if (checkAccess && isEssential) return 'access';
        if (isLimitReached) return 'limit';
        return null;
    };

    return { getAccessType, isDemo };
}

export default useAccessType;
